import {useCallback, useState} from 'react';
import {PLAYER_STATE} from "utils/constants";

/*
 * isCreativeStudioPreviewMode suppresses recording submissions: studio's live preview is not interactive, so a survey
 * must never look submitted there. Note this used to be keyed off isODCEngagementPreviewEnabled, which conflated
 * "render this card standalone with no video" with "this preview is inert" - the standalone shared card preview page
 * needs the former without the latter, so that submitting a survey closes the card as it does in a live creative.
 */
export function useSurveys(isCreativeStudioPreviewMode, hotspotOverlay, playerState, setHotspotOverlay, playerControlWrapper) {
  const [surveySubmitted, setSurveySubmitted] = useState({});

  const isSurveySubmitted = useCallback((surveyId) => {
    return Boolean(surveySubmitted[surveyId]);
  }, [surveySubmitted]);

  const setPreviousSessionSubmittedSurveys = (surveyList) => {
     const submittedSurveys = {}
     surveyList.forEach((surveyId) => {
       submittedSurveys[surveyId] = true;
     })
    setSurveySubmitted(submittedSurveys);
  }

  const submitSurvey = useCallback((surveyId) => {
    if (hotspotOverlay) {
      setHotspotOverlay(null);
      if (playerState !== PLAYER_STATE.COMPLETED) {
        playerControlWrapper.play();
      }
    }
    if(isCreativeStudioPreviewMode) {
      return;
    }
    const surveySubmittedState = {
      ...surveySubmitted,
      [surveyId]: {
        submitted: true,
      }
    };
    setSurveySubmitted(surveySubmittedState);
  }, [hotspotOverlay, surveySubmitted, setHotspotOverlay, playerState, playerControlWrapper, isCreativeStudioPreviewMode]);

  // Hotspot Click Through for Survey Cards are treated as Survey Submitted Event - Refer VGO-3628
  const submitSurveyByHotspotClickThrough = useCallback((surveyId)=> {
    const surveySubmittedState = {
      ...surveySubmitted,
      [surveyId]: {
        submitted: true,
      }
    };
    setSurveySubmitted(surveySubmittedState);
  }, [surveySubmitted]);

  const fetchAllSurveySubmitted = useCallback(() => {
    return Object.keys(surveySubmitted)
  }, [surveySubmitted])

  return {
    isSurveySubmitted,
    submitSurvey,
    submitSurveyByHotspotClickThrough,
    fetchAllSurveySubmitted,
    setPreviousSessionSubmittedSurveys
  };
}
